import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as RightArrow } from "../../../../assets/svgs/rightArrow.svg";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { Button, Modal } from "antd";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import CreateUsers from "./DailogBoxes/CreateUsers";
import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as EyeOutlined } from "../../../../assets/svgs/eye-icon.svg";
import { ReactComponent as EditOutlined } from "../../../../assets/svgs/edit-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { API_URLS } from "../../../../api/apiUrls";
import { getApi, postApi, putApi } from "../../../../api/api_instance";
import { patchApi } from "../../../../api/api_instance";
import EditUsersDialog from "./DailogBoxes/EditUsers";
import { AiFillFileExcel, AiFillFilePdf } from "react-icons/ai";
import { Badge } from "../../../../components/Elements/TextStyles/Badge";
import { CheckCircleOutlined } from "@ant-design/icons";
import { AcceptDialog } from "../../../../components/Elements/DialogBox/AcceptDialog";
import { useSelector } from "react-redux";
import { THEME_COLORS } from "../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import PopupCard from "../../../Auth/PopupCard";
import PermissionForm from "../../../Auth/PermissionForm";
import { useDebounce } from "../../../../hooks/debouncing";
import UserFilter from "../Projects/DailogBoxes/UserFilter";
import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filter-icon.svg";
const headers = [
  { label: "Sr. No.", key: "serial" },
  { label: "Name", key: "name" },
  { label: "Email", key: "username" },
  { label: "Role", key: "role" },
  // { label: "Location", key: "location" },
  { label: "Status", key: "status" },
  { label: "Action", key: "action" },
];
const OrganizationUsers = () => {
  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openCreateDailog, setOpenCreateDailog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [pageNo, setPageNo] = useState(location.state?.pageNo || 1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [showExportOptions, setShowExportOptions] = useState(false);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState(
    location.state?.searchTerm || "",
  );
  const debouncedSearch = useDebounce(searchTerm, 500);
  const [isSuccess, setIsSuccess] = useState(true);
  const [tableData, setTableData] = useState([]);
  const exportRef = useRef(null);
  const user_data = useSelector((state) => state.auth.user);
  const clientId = user_data?.client_id?._id || user_data?._id;
  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  const [filterData, setFilterData] = useState(
    location.state?.filterData || { status: "", role: "" },
  );
  //console.log(isPermissionCompleted, "PermissionFormPermissionForm");
  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);
  // Add popup states
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });
  const [popupActions, setPopupActions] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const pageSize = 10;

  // Trigger popup function similar to CreateUsers component
  const triggerPopup = (type, title, message, duration = 2000) => {
    setPopupActions(null);
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  useEffect(() => {
    fetchUsers(pageNo);
  }, [pageNo, debouncedSearch, filterData]);

  const formatRole = (role) => {
    if (!role) return "";
    return role
      ?.replace(/_/g, " ")
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  };

  // Updated fetchUsers function - store raw data separately for search
  const fetchUsers = async (page = 1) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_USER_BY_CLIENT_ID(
          clientId,
          page,
          pageSize,
          debouncedSearch,
          filterData,
        ),
      });
      console.log(response);

      if (response?.success && response?.data && response.data.length > 0) {
        // Store raw user data for search functionality
        setTableData(
          response.data.map((user, index) => ({
            key: user._id,
            serial: (page - 1) * pageSize + (index + 1),
            name: user.name,
            username: user.email,
            email: user.email,
            role: Array.isArray(user.role)
              ? user.role.map(formatRole).join(" ")
              : formatRole(user.role) || "N/A",
            status: user.status,
            rawData: user, // Keep original user data for actions
          })),
        );

        // Create display data with JSX formatting
        const displayUsersData = response.data.map((user, index) => ({
          key: user._id,
          serial: (
            <div className="text-center" title="">
              {(page - 1) * pageSize + (index + 1)}
            </div>
          ),
          name: (
            <div className="text-center" title="">
              {user.name}
            </div>
          ),
          username: (
            <div className="text-center" title="">
              {user.email}
            </div>
          ),
          email: (
            <div className="text-center" title="">
              {user.email}
            </div>
          ),
          role: (
            <div className="text-center whitespace-pre-wrap" title="">
              {Array.isArray(user.role)
                ? user.role.map(formatRole).join(", \n")
                : formatRole(user.role) || "N/A"}
            </div>
          ),
          status: (
            <div className="flex justify-center" title="">
              <Badge text={user.status} />
            </div>
          ),
          action: (
            <div
              className="flex gap-1 sm:gap-2 items-center justify-center"
              title=""
            >
              <EyeOutlined
                className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
                onClick={() => {
                  console.log(`View user: ${user._id}`);
                  navigate("/organization/user-management/user-details", {
                    state: {
                      userId: user._id,
                      source: "users-list",
                      pageNo,
                      searchTerm,
                      filterData,
                    },
                  });
                }}
              />
              <EditOutlined
                className="w-4 h-4 sm:w-5 sm:h-5 cursor-pointer hover:scale-110 transition-transform"
                onClick={() => {
                  setSelectedUser(user);
                  setOpenEditDialog(true);
                }}
              />
              <CustomSwitch
                checked={user.status === "Active"}
                onChange={() => handleToggleStatus(user._id, user.status)}
              />
            </div>
          ),
          // Keep raw data for search
          rawName: user.name,
          rawUsername: user.email,
          rawRole: Array.isArray(user.role)
            ? user.role.map(formatRole).join(" ")
            : formatRole(user.role) || "N/A",
        }));

        setUsers(displayUsersData);
        setFilteredData(displayUsersData);
        setTotalUsers(response.total);
      } else {
        // Handle case when no data found or success is false
        console.log("No users found or API returned success: false");
        setUsers([]);
        setFilteredData([]);
        setTotalUsers(0);

        // Show popup message when no records found
        // if (response?.message) {
        //   triggerPopup("info", "No Users Found", response.message);
        // }
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      // Handle error case and show error popup
      setUsers([]);
      setFilteredData([]);
      setTotalUsers(0);
      // triggerPopup("error", "Error", "Failed to fetch users");
    }
  };

  const handleToggleStatus = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await putApi({
        apiUrl: API_URLS.UPDATE_USER(userId),
        data: { status: newStatus },
      });

      if (response?.success) {
        triggerPopup(
          "success",
          "Status Updated",
          `User status changed to ${newStatus} successfully`,
        );
        fetchUsers(pageNo);
      } else {
        triggerPopup(
          "error",
          "Update Failed",
          response?.message || "Failed to update user status",
        );
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      triggerPopup(
        "error",
        "Update Failed",
        "Something went wrong while updating user status",
      );
    }
  };

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
    setFilteredData((prevData) => {
      return SortData({ data: [...prevData], key, order });
    });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (exportRef.current && !exportRef.current.contains(event.target)) {
        setShowExportOptions(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      {/* Main Container with responsive padding */}
      <div>
        <div className="flex flex-wrap justify-end text-xs font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>User Management</TextStyles>
        </div>

        {/* Title & Back Icon */}
        <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px]  leading-none tracking-tight">
            User Management
          </div>
        </div>

        <div className="border border-[#3BA2B959] rounded-lg sm:rounded-xl bg-white shadow-sm overflow-hidden ">
          {/* Top Controls Section */}
          <div className="p-4 sm:py-2 sm:px-4 border-b border-gray-100">
            <div className="bg-white rounded-xl  pt-6">
              {/* Responsive Header Section */}
              <div className="flex flex-col lg:flex-row lg:justify-between gap-4 px-4 sm:px-6 mb-4">
                {/* Left Section: Total Users + Search */}
                <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full lg:w-auto">
                  {/* Total Users */}
                  <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
                    <div className="bg-[#E6EEEC] border border-[#06513D]  text-[#005E45] rounded-md text-[14px] font-medium px-4 py-3 w-full sm:w-auto text-center sm:text-left">
                      TOTAL USERS {totalUsers}
                    </div>
                  </div>

                  {/* Search Bar */}
                  <div className="w-full sm:w-auto flex-1">
                    <SearchBar
                      width="100%"
                      height="42px"
                      onSearch={(value) => {
                        setSearchTerm(value);
                        setPageNo(1);
                      }}
                    />
                  </div>
                  <Button
                    onClick={() => setOpenFilter(true)}
                    style={{
                      color: "#06513D",
                      background: "#E6EDEB",
                      border: "solid 1px #06513D",
                    }}
                    className="text-[12px] hover:!bg-[#F8F8F8]  text-[#06513D] font-light px-4 py-5 ml-4"
                  >
                    <FilterIcon /> FILTER
                  </Button>
                </div>

                {/* Right Section: Buttons */}
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
                  {/* Export Button with Dropdown */}
                  <div className="relative w-full sm:w-auto" ref={exportRef}>
                    <Button
                      type="primary"
                      className="text-sm w-full sm:w-auto h-11 border-none rounded-lg font-calibri font-light"
                      style={{ backgroundColor: THEME_COLORS.green }}
                      onClick={() => setShowExportOptions((prev) => !prev)}
                    >
                      Export
                    </Button>

                    {showExportOptions && (
                      <div className="absolute top-full  mt-2 w-52 bg-white border border-gray-300 rounded-md shadow-lg z-20">
                        <div
                          className="flex items-center gap-2 px-4 py-3 hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            setShowExportOptions(false);
                            triggerPopup(
                              "success",
                              "Export",
                              "Exporting to Excel...",
                            );
                          }}
                        >
                          <AiFillFileExcel className="text-green-600 text-xl" />
                          <span>Export to Excel</span>
                        </div>
                        <div
                          className="flex items-center gap-2 px-4 py-3 hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            setShowExportOptions(false);
                            triggerPopup(
                              "success",
                              "Export",
                              "Exporting to PDF...",
                            );
                          }}
                        >
                          <AiFillFilePdf className="text-red-600 text-xl" />
                          <span>Export to PDF</span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Import Button */}
                  <Button
                    type="primary"
                    className="text-sm w-full sm:w-auto h-11 border-none rounded-lg font-calibri font-light"
                    style={{ backgroundColor: THEME_COLORS.green }}
                    onClick={() => navigate("import-users")}
                  >
                    Import
                  </Button>

                  {/* Add New Button */}
                  <Button
                    type="primary"
                    className="text-sm w-full sm:w-auto h-11 border-none rounded-lg font-calibri font-light"
                    style={{ backgroundColor: THEME_COLORS.green }}
                    onClick={() => setOpenCreateDailog(true)}
                  >
                    Add New
                  </Button>
                </div>
              </div>
            </div>

            {/* Mobile Layout - Stacked */}
            {/* <div className="block lg:hidden space-y-4"> */}
            {/* Total Users Badge */}

            {/* Mobile View */}
            <div className="block lg:hidden p-4 sm:p-6">
              {tableData.length > 0 ? (
                <>
                  {tableData.map((user, index) => {
                    const raw = user.rawData || {}; // for direct data access
                    return (
                      <div
                        key={user.key}
                        className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 mb-4 transform transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:border-[#3BA2B9]"
                        style={{
                          animationDelay: `${index * 0.05}s`,
                          background:
                            "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
                          border: "1px solid #e0f2f1",
                        }}
                      >
                        {/* Header */}
                        <div className="flex justify-between items-center mb-3 pb-2 border-b border-gray-100">
                          <span className="bg-gradient-to-r from-[#06513D] to-[#3BA2B9] text-white text-sm font-bold px-4 py-1 rounded-full">
                            #{(pageNo - 1) * pageSize + (index + 1)}
                          </span>
                          <Badge text={raw.status} />
                        </div>

                        {/* Name */}
                        <div className="flex justify-between items-start mb-2">
                          <span className="text-sm font-semibold text-gray-600 min-w-[90px]">
                            Name:
                          </span>
                          <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3">
                            {raw.name || "N/A"}
                          </span>
                        </div>

                        {/* Email */}
                        <div className="flex justify-between items-start mb-2">
                          <span className="text-sm font-semibold text-gray-600 min-w-[90px]">
                            Email:
                          </span>
                          <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3 break-all">
                            {raw.email || "N/A"}
                          </span>
                        </div>

                        {/* Role */}
                        <div className="flex justify-between items-start mb-3">
                          <span className="text-sm font-semibold text-gray-600 min-w-[90px]">
                            Role:
                          </span>
                          <span className="text-sm font-medium text-gray-800 text-right flex-1 ml-3 whitespace-pre-wrap">
                            {Array.isArray(raw.role)
                              ? raw.role
                                  .map((r) => r.replace(/_/g, " "))
                                  .join(", ")
                              : raw.role || "N/A"}
                          </span>
                        </div>

                        {/* Actions */}
                        <div className="flex justify-end items-center gap-3 pt-3 border-t border-gray-100">
                          <EyeOutlined
                            className="w-5 h-5 cursor-pointer hover:text-[#06513D] hover:scale-110 transition-transform"
                            onClick={() =>
                              navigate(
                                "/organization/user-management/user-details",
                                {
                                  state: { userId: raw._id },
                                },
                              )
                            }
                          />
                          <EditOutlined
                            className="w-5 h-5 cursor-pointer hover:text-[#3BA2B9] hover:scale-110 transition-transform"
                            onClick={() => {
                              setSelectedUser(raw);
                              setOpenEditDialog(true);
                            }}
                          />
                          <CustomSwitch
                            checked={raw.status === "Active"}
                            onChange={() =>
                              handleToggleStatus(raw._id, raw.status)
                            }
                          />
                        </div>
                      </div>
                    );
                  })}

                  {/* Mobile Pagination Info */}
                  <div className="flex justify-center items-center gap-4 mt-6">
                    <Button
                      onClick={() => setPageNo((prev) => Math.max(1, prev - 1))}
                      disabled={pageNo === 1}
                      className={`px-4 py-2 rounded-md transition-all duration-300 ${
                        pageNo === 1
                          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                          : "bg-[#06513D] text-white hover:bg-[#04422F]"
                      }`}
                    >
                      Previous
                    </Button>

                    <span className="text-sm font-medium text-gray-700">
                      Page {pageNo} of {Math.ceil(totalUsers / pageSize)}
                    </span>

                    <Button
                      onClick={() =>
                        setPageNo((prev) =>
                          prev < Math.ceil(totalUsers / pageSize)
                            ? prev + 1
                            : prev,
                        )
                      }
                      disabled={pageNo === Math.ceil(totalUsers / pageSize)}
                      className={`px-4 py-2 rounded-md transition-all duration-300 ${
                        pageNo === Math.ceil(totalUsers / pageSize)
                          ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                          : "bg-[#06513D] text-white hover:bg-[#04422F]"
                      }`}
                    >
                      Next
                    </Button>
                  </div>

                  {/* Mobile Summary */}
                  <div className="text-center text-sm text-gray-600 mt-4">
                    Showing {(pageNo - 1) * pageSize + 1}–
                    {Math.min(pageNo * pageSize, totalUsers)} of {totalUsers}{" "}
                    users
                  </div>
                </>
              ) : (
                <div className="text-center py-10 text-gray-500">
                  <p>No users found</p>
                </div>
              )}
            </div>

            {/* Desktop Layout - Horizontal */}
          </div>

          {/* Table Container */}
          <div className="hidden lg:block overflow-x-auto">
            {/* {filteredData.length > 0 ? (
              <div className="min-w-full">
                <Tables
                  data={filteredData}
                  headers={headers}
                  pageSize={pageSize}
                  current={pageNo}
                  total={totalUsers}
                  onChange={(page) => {
                    setPageNo(page);
                  }}
                  sortBy={sortBy}
                  sortOrder={sortOrder}
                  onSort={handleSort}
                />
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="text-gray-400 text-8xl mb-6">👥</div>
                <p className="text-gray-500 text-xl font-medium mb-2">
                  No users found
                </p>
                <p className="text-gray-400 text-base">
                  Try adjusting your search criteria or add new users
                </p>
              </div>
            )} */}
            <Tables
              data={filteredData}
              headers={headers}
              pageSize={pageSize}
              current={pageNo}
              total={totalUsers}
              onChange={(page) => {
                setPageNo(page);
              }}
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={handleSort}
            />
          </div>
        </div>

        {/* Dialogs */}
        {openCreateDailog && (
          <CreateUsers
            onOpen={openCreateDailog}
            onClose={() => {
              setOpenCreateDailog(false);
              // Refresh users after creating new user
              fetchUsers(pageNo);
            }}
          />
        )}

        {openEditDialog && selectedUser && (
          <EditUsersDialog
            onOpen={openEditDialog}
            onClose={() => {
              setOpenEditDialog(false);
              // Refresh users after editing
              fetchUsers(pageNo);
            }}
            userData={selectedUser}
            onUpdate={fetchUsers}
          />
        )}

        {/* Replace AcceptDialog with triggerPopup */}
        {/* {showStatusDialog && (
          <AcceptDialog
            open={showStatusDialog}
            close={() => setShowStatusDialog(false)}
            subheading={statusMessage}
            success={isSuccess}
            failed={!isSuccess}
          />
        )} */}

        {/* Popup for messages */}
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
              onConfirm={popupActions?.onConfirm}
              onCancel={popupActions?.onCancel}
              confirmText={popupActions?.confirmText}
              cancelText={popupActions?.cancelText}
            />
          </div>
        )}
        {openFilter && (
          <UserFilter
            onOpen={openFilter}
            onClose={() => setOpenFilter(false)}
            setFilterData={setFilterData}
            initialFilter={filterData}
          />
        )}
      </div>

      <style jsx>{`
        .center-aligned-table .ant-table-tbody > tr > td {
          text-align: center !important;
          word-wrap: break-word !important;
          word-break: break-word !important;
          white-space: normal !important;
          padding: 12px 8px !important;
        }

        .center-aligned-table .ant-table-thead > tr > th {
          text-align: center !important;
        }

        .center-aligned-table .ant-table-cell {
          vertical-align: middle !important;
        }
      `}</style>
    </div>
  );
};

export default OrganizationUsers;
